import { Event } from "../models/enums";
export class EventBus {
    constructor(bus) {
        this.bus = bus;
    }
    static getInstance() {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus(document.body);
        }
        return EventBus.instance;
    }
    addEventListener(event, callback) {
        this.bus.addEventListener(event, callback);
    }
    removeEventListener(event, callback) {
        this.bus.removeEventListener(event, callback);
    }
    dispatchEvent(event, detail = {}) {
        this.bus.dispatchEvent(new CustomEvent(event, { detail }));
    }
    dispatchInfo(text, classes) {
        this.dispatchEvent(Event.Toast, {
            text: text,
            classes: classes,
            type: "is-info",
        });
    }
    dispatchError(error) {
        const e = JSON.parse(error.body);
        this.dispatchEvent(Event.Toast, {
            text: e.errortext,
            classes: "fas fa-exclamation",
            type: "is-danger",
        });
    }
}
//# sourceMappingURL=eventbus.service.js.map